
import { Component, Vue } from 'vue-property-decorator';

import { VendorContractPublic } from '../../../../common/application/model/VendorContractPublic';
import { getGoogleMapsLinkForContract } from '../../service/google_maps_helper_service';

@Component
export default class CustomerServiceInfo extends Vue {
    goToHomePage() {
        this.$emit('goToHomePage');
    }

    get googleMapsLink(): string {
        const smartFleetVendor = {
            vendorLocationStreet: this.$t('label.smartFleetStreet'),
            vendorLocationCity: this.$t('label.smartFleetCity'),
            vendorLocationZip: this.$t('label.smartFleetZip'),
        } as VendorContractPublic;
        return getGoogleMapsLinkForContract(smartFleetVendor);
    }
}
